/**
 * 왓퀴즈 인터랙티브 데모 - 핵심 기능을 탭으로 보여줌
 * (생기부 / 반 전체 / 채점 / PPT / 채팅)
 *
 * 탭 스타일은 AdProLandingPage.css(.adpro-d-*)를, 데모 화면은 components/demo 를 쓴다.
 *
 * Usage:
 *   import InteractiveDemo from '../../components/landing/InteractiveDemo';
 *   import '../landing/ad-pro/AdProLandingPage.css';
 *   <InteractiveDemo defaultTab={1} surface="school" />
 */

import React, { useState } from 'react';
import {
  ChatAnswerDemo,
  ClassFlowDemo,
  PptEditDemo,
  SaenggibuResultDemo,
  ScoringScanDemo,
  trackDemoCta,
} from '../demo';

export const DEMO_TABS = [
  { key: 'saenggibu', label: 'AI 생기부', path: '/create-saenggibu', Demo: SaenggibuResultDemo },
  { key: 'class_flow', label: '반 전체 생기부', path: '/create-saenggibu?mode=batch', Demo: ClassFlowDemo },
  { key: 'scoring_scan', label: 'AI 채점', path: '/scoring', Demo: ScoringScanDemo },
  { key: 'ppt_edit', label: 'AI PPT', path: '/chat?category=ppt_maker', Demo: PptEditDemo },
  { key: 'chat', label: 'AI 채팅', path: '/chat', Demo: ChatAnswerDemo },
];

const InteractiveDemo = ({
  defaultTab = 0,
  ctaLabel = '무료로 체험하기',
  surface = 'interactive_demo',
  onCtaClick,
}) => {
  const [activeDemo, setActiveDemo] = useState(
    Math.min(Math.max(defaultTab, 0), DEMO_TABS.length - 1),
  );
  const [userPicked, setUserPicked] = useState(false);
  const tab = DEMO_TABS[activeDemo];
  const { Demo } = tab;

  const handleCtaClick = () => {
    trackDemoCta(surface, tab.key, tab.path);
    if (onCtaClick) {
      onCtaClick(tab);
      return;
    }
    window.open(tab.path, '_blank');
  };

  return (
    <div className="adpro-demos-inner">
      <div className="adpro-d-tabs" role="tablist">
        {DEMO_TABS.map((d, i) => (
          <button
            key={d.key}
            type="button"
            role="tab"
            aria-selected={activeDemo === i}
            className={`adpro-d-tab${activeDemo === i ? ' active' : ''}`}
            onClick={() => {
              setActiveDemo(i);
              setUserPicked(true);
            }}
          >
            {d.label}
          </button>
        ))}
      </div>
      <div className="adpro-d-area">
        <Demo key={tab.key} surface={surface} autoStart={userPicked} />
      </div>
      <div style={{ textAlign: 'center', marginTop: '24px' }}>
        <button
          type="button"
          onClick={handleCtaClick}
          style={{
            background: '#3182f6',
            color: '#fff',
            border: 'none',
            minHeight: '48px',
            padding: '14px 28px',
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {tab.label} {ctaLabel} →
        </button>
      </div>
    </div>
  );
};

export default InteractiveDemo;
